import { ObjectStorage } from "../ObjectStorage";

class WalletSecureStorage extends ObjectStorage {
    public isSecure = true;
    public key = 'wallet_secure';
   // public oldKey = 'wallet';
}

export default WalletSecureStorage.getInstance(WalletSecureStorage);
